import { styled } from 'linaria/lib/react';
import React, { FC } from 'react';
import { Icon } from '@mtsbank/ui-kit';
export const SpinnerSmall: FC = () => <SpinnerWrapper>
    <Icon icon="other/whiteSpinner" />
  </SpinnerWrapper>;
const SpinnerWrapper = /*#__PURE__*/styled("div")({
  name: "SpinnerWrapper",
  class: "s80rpm2"
});

require("./SpinnerSmall.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./SpinnerSmall.tsx");